export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TeamListingItem.vue?vue&type=template&id=2b035689&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TeamListingItem.vue?vue&type=template&id=2b035689&scoped=true&
// module id = 385
// module chunks = 0